import { render, staticRenderFns } from "./cv-button-skeleton.vue?vue&type=template&id=1dfc3d6c&"
import script from "./cv-button-skeleton.vue?vue&type=script&lang=js&"
export * from "./cv-button-skeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports